type ContactWithId = { id?: number | null };

export function collectContactIds(contacts: ContactWithId[] | null | undefined): number[] {
  return (contacts ?? []).map((c) => c.id).filter((id): id is number => typeof id === 'number' && id > 0);
}
